module.exports = __webpack_public_path__ + "static/media/rose-nails-spa.f02681ca.jpg";